import { agentHubOrSubBrandConfig } from 'agentHub/constants'

/**
 * Leaf flag for CVFR Agent Hub.
 * Kept out of agentHubSelectors so header/nav can use it without
 * pulling commissionMap via agentHubSelectors.
 */
export const isAgentHubCVFREnabled = agentHubOrSubBrandConfig.isCVFREnabled
